import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const GammaLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M17.568108,6 L14.893632,6 C14.798484,6 14.713464,6.05968188 14.681376,6.1486416 L13.514196,9.375408 C13.386384,9.884388 13.357668,10.413084 13.428612,10.933332 L14.73486,17.817 C14.754564,17.92284 14.848032,18 14.95614,18 L17.68464,18 C17.8422,18 17.9514,17.842308 17.89524,17.69484 L15.368268,11.074092 C15.141948,10.482336 15.230904,9.816264 15.604236,9.3039 L17.7504,6.357528 C17.85852,6.2088864 17.75208,6 17.568108,6 Z M13.197816,6 L10.605024,6 C10.458636,6 10.350528,6.1373808 10.386564,6.2798292 L11.11626,9.193548 C11.267148,9.795432 11.301504,10.41984 11.217048,11.034672 L10.300428,17.74434 C10.28184,17.879532 10.387128,18 10.523952,18 L13.278888,18 C13.415712,18 13.520424,17.879532 13.502412,17.74434 L12.585216,11.034108 C12.501336,10.41984 12.53568,9.794868 12.686016,9.192984 L13.416264,6.2798292 C13.451736,6.1379436 13.344204,6 13.197816,6 Z M8.90856,6 L6.2341368,6 C6.0500232,6 5.9436096,6.2088864 6.0517116,6.357528 L8.198568,9.3039 C8.5713,9.816264 8.660268,10.481772 8.434488,11.074092 L5.9081376,17.69484 C5.8518348,17.842308 5.9610636,18 6.1187148,18 L8.846064,18 C8.954172,18 9.047064,17.923404 9.067332,17.817 L10.37358,10.933332 C10.444524,10.413084 10.415244,9.884388 10.287996,9.375408 L9.120816,6.1486416 C9.088164,6.05968188 9.00372,6 8.90856,6 Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="Gamma" className={t2} fill="currentColor" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};